import { render, staticRenderFns } from "./Youtube.vue?vue&type=template&id=78bbb878&scoped=true"
import script from "./Youtube.vue?vue&type=script&lang=ts"
export * from "./Youtube.vue?vue&type=script&lang=ts"
import style0 from "./Youtube.vue?vue&type=style&index=0&id=78bbb878&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bbb878",
  null
  
)

export default component.exports